import service from '../request/index'

//首页
export function homeInfo(data) {
    return service({
      url: '/home/info',
      method: "post",
      data
    })
  }
//玩具首页
export function designHomeIndex(data) {
  return service({
    url: '/design/home_index',
    method: "post",
    data
  })
}
//推荐商品
export function goodsRecommend(data) {
  return service({
    url: '/goods/goods_recommend',
    method: "post",
    data
  })
}
//商品分类+商品
export function categoryIndex(data) {
  return service({
    url: '/category/index',
    method: "post",
    data
  })
}
//商品详情
export function goodsInfo(data) {
  return service({
    url: '/goods/info',
    method: "post",
    data
  })
}
//协议
export function agreementInfo(data) {
  return service({
    url: '/agreement/info',
    method: "post",
    data
  })
}
//about
export function aboutIndex(data) {
  return service({
    url: '/about/index',
    method: "post",
    data
  })
}
//support
export function supportIndex(data) {
  return service({
    url: '/supporttype/index',
    method: "post",
    data
  })
}
//support玩法
export function goodsmethodIndex(data) {
  return service({
    url: '/goodsmethod/index',
    method: "post",
    data
  })
}
//app
export function appInfo(data) {
  return service({
    url: '/app/info',
    method: "post",
    data
  })
}
//邮箱
export function supportMail(data) {
  return service({
    url: '/support/mail',
    method: "post",
    data
  })
}
//验证码
export function supportCaptcha(data) {
  return service({
    url: '/support/captcha',
    method: "post",
    data
  })
}
//验证码 验证
export function supportIscaptcha(data) {
  return service({
    url: '/support/iscaptcha',
    method: "post",
    data
  })
}
//是否在菜单栏显示分类
export function indexSelect(data) {
  return service({
    url: '/categoryfoot/index_select',
    method: "post",
    data
  })
}

//问题列表
export function questionList(data) {
  return service({
    url: '/question/question_list',
    method: "post",
    data
  })
}

//隐私政策/用户协议
export function agreementInfos(data) {
  return service({
    url: '/agreement/agreement',
    method: "post",
    data
  })
}

//问题详情
export function questionInfo(id, type, data) {
  return service({
    url: '/question/question_info?question_id=' + id + '&type=' + type,
    method: "post",
    data
  })
}